<template>
    <v-navigation-drawer id="main-navigation"
            persistent
            clipped
            floating
            height="100%"
            light
            class="pb-0 grey lighten-5"
            enable-resize-watcher
            v-model="isActive"
    >
        <v-list dense class="grey lighten-5">
            <v-container v-if="showProfile" pa-0 ma-0 hidden-md-and-up text-xs-center>
                <v-list three-line dense class="grey lighten-5">
                    <v-list-tile>
                        <v-list-tile-avatar>
                            <img v-bind:src="profile.picture">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title v-html="profile.name"></v-list-tile-title>
                            <v-list-tile-sub-title class="grey--text text--darken-4" v-html="profile.email"></v-list-tile-sub-title>
                            <v-list-tile-sub-title v-html="profile.sub"></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
                <v-flex text-xs-right>
                    <v-spacer></v-spacer>
                    <v-btn primary flat @click="signOut()" text-xs-right>Sign out</v-btn>
                </v-flex>
                <v-divider dark class="my-1"></v-divider>
            </v-container>

            <template v-for="(item, i) in items">
                <v-layout
                        row
                        v-if="item.heading"
                        align-center
                        :key="i"
                >
                    <v-flex xs6>
                        <v-subheader v-if="item.heading">
                            {{ item.heading }}
                        </v-subheader>
                    </v-flex>
                    <v-flex xs6 class="text-xs-center">
                        <v-btn small flat v-if="item.editable">edit</v-btn>
                    </v-flex>
                </v-layout>
                <v-divider
                        dark
                        v-else-if="item.divider"
                        class="my-1"
                        :key="i"
                ></v-divider>
                <v-list-tile
                        :key="i"
                        v-else
                        @click="nav(item)"
                >
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{ item.text }}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { isAuthenticated } from '../store/auth';
    import { download } from '../utils/api';

    export default {
        name: 'main-navigation',
        data() {
            return {
                // drawer items
                items: [
                    { icon: 'bubble_chart', text: 'Intents', route: '/intents' },
                    { icon: 'swap_calls', text: 'Consents', route: '/consents' },
                    { divider: true },
                    { heading: 'Meta', editable: false },
                    { icon: 'data_usage', text: 'Properties', route: '/properties' },
                    { icon: 'data_usage', text: 'Providers', route: '/providers' },
                    { icon: 'file_download', text: 'Mappings', download: '/profileProvidersSchemaEnpointMappings?format=csv', file: 'Mappings.csv' },
                    { divider: true },
                    { heading: 'Support', editable: false },
                    { icon: 'domain', text: 'Organisation', route: '/organisation' },
                    { icon: 'mdi-account', text: 'Users', route: '/organisation/users' },
                    { icon: 'settings', text: 'Settings', route: '/settings' },
                ],
            };
        },
        computed: {
            ...mapGetters('auth', [
                'profile',
            ]),
            isActive: {
                get() {
                    return this.$store.state.nav.sidebar;
                },
                set(value) {
                    this.$store.commit('nav/SIDEBAR', value);
                },
            },
            showProfile() {
                return isAuthenticated();
            },
        },
        methods: {
            nav(item) {
                if (item.route) {
                    this.goto(item.route);
                } else if (item.download) {
                    download(item.download, item.file);
                }
            },
            goto(route) {
                this.$router.push({ path: route });
            },
            signOut() {
                this.$store.commit('auth/LOGOUT');
                this.$router.push({ path: '/login' });
            },
        },
    };
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// MainNavigation.vue?499ca31b